// App.js
import './index.css';
import { Route, Routes } from 'react-router-dom';

import UniversalPage from './components/UniversalPage';

import { TwgoldAuthProvider } from './components/TWGold/TWGLogin/TwgoldAuthContext';
import TwgoldLogin from './components/TWGold/TWGLogin/TwgoldLogin';
import { TwgoldProtectedRoute } from './components/TWGold/TWGLogin/TwgoldProtectedRoute';
import TwgoldAdminDashboard from './components/TWGold/Admin/TwgoldAdminDashboard';
// import TwgoldManagerDashboard from './components/TWGold/Manager/TwgoldManagerDashboard';
import TwgoldEmployeeDashboard from './components/TWGold/Employee/EmployeeDashboard';
import TwgoldGrivirenceDashboard from './components/TWGold/Grivirence/TwgoldGrivirenceDashboard';
import GoldRates from './components/TWGold/Admin/GoldRates';
import CreatingEmployee from './components/TWGold/Admin/CreatingEmployee';
import TWgoldBranchCreate from './components/TWGold/Admin/TWgoldBranchCreate';
import TwgoldHome from './components/TWGold/Home/TwgoldHome';
import Twgoldemployeeloan from './components/TWGold/Employee/Twgoldemployeeloan';
import ManageBranches from './components/TWGold/Admin/ManageBranches';
import EditBranch from './components/TWGold/Admin/EditBranch';
import TWgoldAccountOpeningForm from './components/TWGold/Employee/TWgoldAccountOpeningForm';
import ManagerLayout from './components/TWGold/Manager/layout/ManagerLayout';
import DashboardContainer from './components/TWGold/Manager/containers/DashboardContainer';
import NewLoanContainer from './components/TWGold/Manager/containers/NewLoanContainer';
import LoanListContainer from './components/TWGold/Manager/containers/LoanListContainer';
import InventoryContainer from './components/TWGold/Manager/containers/InventoryContainer';
import CustomersContainer from './components/TWGold/Manager/containers/CustomersContainer';
import RepaymentsContainer from './components/TWGold/Manager/containers/RepaymentsContainer';
import ReportsContainer from './components/TWGold/Manager/containers/ReportsContainer';
import UsersContainer from './components/TWGold/Manager/containers/UsersContainer';
import ManageEmployees from './components/TWGold/Admin/ManageEmployees';




function App() {
  return (
    <TwgoldAuthProvider>
      <div>
        <Routes>


          {/* TWGold Public Routes - No protection needed */}
          <Route path="/" element={<TwgoldHome />} />
          <Route path="/twgl&articles/login" element={<TwgoldLogin />} />
          {/* TWGold Protected Routes - Only for authenticated users */}
          <Route path="/twgl&articles/admin/dashboard" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <TwgoldAdminDashboard />
            </TwgoldProtectedRoute>
          } />
          <Route path="/twgl&articles/admin/branches" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <ManageBranches />
            </TwgoldProtectedRoute>
          } />
          <Route path="/twgl&articles/admin/branches/edit/:branchId" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <EditBranch />
            </TwgoldProtectedRoute>
          } />
          <Route path="/twgl&articles/admin/branches/create" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <TWgoldBranchCreate />
            </TwgoldProtectedRoute>
          } />
          <Route path="/twgl&articles/admin/manageemployees" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <ManageEmployees />
            </TwgoldProtectedRoute>
          } />

          <Route path="/twgl&articles/admin/employees" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <CreatingEmployee />
            </TwgoldProtectedRoute>
          } />

          <Route path="/twgl&articles/admin/gold-rates" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <GoldRates />
            </TwgoldProtectedRoute>
          } />

          <Route path="/twgl&articles/admin/loans" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <TwgoldAdminDashboard />
            </TwgoldProtectedRoute>
          } />

          <Route path="/twgl&articles/admin/settings" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <TwgoldAdminDashboard />
            </TwgoldProtectedRoute>
          } />

          <Route path="/twgl&articles/admin/audit" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <TwgoldAdminDashboard />
            </TwgoldProtectedRoute>
          } />

          <Route path="/twgl&articles/admin/compliance" element={
            <TwgoldProtectedRoute allowedRoles={['admin']}>
              <TwgoldAdminDashboard />
            </TwgoldProtectedRoute>
          } />

          <Route
            path="/twgl&articles/manager"
            element={
              <TwgoldProtectedRoute allowedRoles={['manager', 'rm', 'zm']}>
                <ManagerLayout />
              </TwgoldProtectedRoute>
            }
          >
            {/* Default */}
            <Route index element={<DashboardContainer />} />

            {/* Pages */}
            <Route path="dashboard" element={<DashboardContainer />} />
            <Route path="new-loan" element={<NewLoanContainer />} />
            <Route path="loans" element={<LoanListContainer />} />
            <Route path="inventory" element={<InventoryContainer />} />
            <Route path="repayments" element={<RepaymentsContainer />} />
            <Route path="customers" element={<CustomersContainer />} />
            <Route path="reports" element={<ReportsContainer />} />
            <Route path="users" element={<UsersContainer />} />
          </Route>

          <Route
            path="/twgl&articles/employee/dashboard"
            element={
              <TwgoldProtectedRoute
                allowedRoles={['employee', 'cashier', 'accountant', 'sales_marketing']}
              >
                <TwgoldEmployeeDashboard />
              </TwgoldProtectedRoute>
            }
          />

          <Route path="/twgl&articles/employee/customer/create" element={
            <TwgoldProtectedRoute allowedRoles={['employee', 'cashier', 'accountant', 'sales_marketing']}>
              <TWgoldAccountOpeningForm />
            </TwgoldProtectedRoute>
          } />
          <Route path="/twgl&articles/employee/goldloan" element={
            <TwgoldProtectedRoute allowedRoles={['employee', 'cashier', 'accountant', 'sales_marketing']}>
              <Twgoldemployeeloan />
            </TwgoldProtectedRoute>
          } />

          <Route path="/twgl&articles/grivirence/dashboard" element={
            <TwgoldProtectedRoute allowedRoles={['grivirence']}>
              <TwgoldGrivirenceDashboard />
            </TwgoldProtectedRoute>
          } />

          {/* Catch-all Route */}
          <Route path="*" element={<UniversalPage />} />
        </Routes>
      </div>
    </TwgoldAuthProvider>
  );
}

export default App;
